/**
 * Handle primary header change on scroll and handle specific menu clicks
 */
( function () {

    Element.prototype.removeAttributes = function ( ...attrs ) {
        attrs.forEach( attr => this.removeAttribute( attr ) );
    }

    const primaryHeader = document.querySelector( '.site-header' );
    const adminBar = document.getElementById( 'wpadminbar' );
    const mainMenu = document.querySelector( '.site-header__main-menu' );
    const mainSubMenuLinks = mainMenu.querySelectorAll( ':scope > .menu-item-has-children > a' );
    const headerExtraMenu = primaryHeader.querySelector( '.site-header__menu-extra' );

    const megaMenuWrapper = primaryHeader.querySelector( '.site-megamenu-wrapper' );
    const megaMenuColMain = document.querySelector( '.site-megamenu__col-main' );
    const megaMenuColSub = document.querySelector( '.site-megamenu__col-sub' );
    const megaMenuColImage = document.querySelector( '.site-megamenu__col-image' );

    const isDevSite = /^dev\./.test(location.hostname.toLowerCase());
    const isMobile = window.viewportName === 'small';

    let onRemoveCallback = null;

    function isViewportSize(size) {
        const sizesToCheck = Array.isArray(size) ? [...size] : [size];

        return sizesToCheck.includes( window.viewportName );
    }

    // function addMenuItemIndexes() {
    //     mainMenu.querySelectorAll( ':scope > .menu-item' )?.forEach( (menuItem, index) => {
    //         menuItem.style.setProperty( '--index', index + 1 );
    //     });

    //     mainMenu.querySelectorAll( '.sub-menu' )?.forEach( subMenu => {
    //         subMenu.querySelectorAll( ':scope > .menu-item' )?.forEach( (menuItem, index) => {
    //             menuItem.style.setProperty( '--index', index + 1 );
    //         });
    //     });
    // }

    function setHeaderOffset() {
        if ( ! primaryHeader ) {
            return;
        }

        if ( adminBar ) {
            primaryHeader.style.setProperty( '--offset', `${adminBar.offsetHeight}px` );
        }

        if ( megaMenuWrapper ) {
            megaMenuWrapper.style.setProperty( '--offset', `${primaryHeader.getBoundingClientRect().top + primaryHeader.offsetHeight}px` );
        }
    }

    function toggleMenu() {
        if ( megaMenuWrapper.hasAttribute( 'opening') ) {
            return;
        }

        if ( ! primaryHeader.hasAttribute( 'menu-open') ) {
            primaryHeader.setAttribute( 'opening', '' );
        } else {
            if ( ! megaMenuWrapper.hasAttribute( 'open' ) ) {
                primaryHeader.removeAttribute( 'menu-open' );
                return
            }

            primaryHeader.setAttribute( 'closing', '' );
            closeMegaMenu();
        }
    }

    function clearActiveItem( container ) {
        const items = container.querySelectorAll( '[data-active]' );

        items.forEach( item => item.removeAttribute( 'data-active' ) );
    }

    function closeMegaMenu() {
        clearMenuItems( megaMenuColSub );
        clearImage( true );
        clearActiveItem( mainMenu );

        megaMenuWrapper.querySelector( '.act-as-subcol' )?.classList.remove( 'act-as-subcol' );

        clearMenuItems( megaMenuColMain, () => {
            // clearMenuItems( megaMenuColSub );
            // clearImage( true );
            // clearActiveItem( mainMenu );

            megaMenuWrapper.addEventListener( 'transitionend', () => {
                if ( primaryHeader.hasAttribute( 'closing' ) ) {
                    primaryHeader.removeAttributes( 'closing', 'menu-open' );
                }
            }, { once: true })

            megaMenuWrapper.removeAttributes( 'loaded', 'open' );
        });
    }

    function clearMenuItems( source, callback = null ) {
        if ( source.children.length === 0 && typeof callback === 'function' ) {
            callback();
            onRemoveCallback = null;
            return;
        }

        Array.from(source.childNodes).forEach( item => {
            item.setAttribute( 'removing', '' );
        });

        onRemoveCallback = callback;
    }

    function copyMenuItems( source, destination ) {
        const subMenu = source?.querySelector( '.sub-menu' );

        if ( ! subMenu ) {
            return;
        }

        Array.from( subMenu.children ).forEach( (item, index) => {
            const newItem = item.cloneNode( true );

            if ( index === (subMenu.children.length - 1) ) {
                newItem.setAttribute( 'last-item', '' );
            }

            destination.append( newItem );
        });

        const parentElement = document.createElement( 'li' );
        parentElement.classList.add( 'menu-item', 'menu-item--first' );
        parentElement.append( source.children[0].cloneNode(true) );

        setItemActiveState( parentElement );

        destination.prepend( parentElement );

        if (
            headerExtraMenu
            && isMobile
            && ! destination.classList.contains( 'act-as-subcol' )
        ) {
            const extraItems = Array.from( headerExtraMenu.querySelector( 'ul' )?.children );

            extraItems.forEach( (item, index) => {
                const newItem = item.cloneNode( true );
                const classes = [ 'menu-item', 'footer-item' ];

                if ( index === 0 ) {
                    classes.push( 'footer-item--first' )
                } else if ( index === (extraItems.length - 1) ) {
                    classes.push( 'footer-item--last' )
                }

                newItem.classList.add( ...classes );
                destination.append( newItem );
            });
        }

        handleImageDisplay( destination );
    }

    function handleImageDisplay( container ) {
        if ( window.viewportName !== 'large' ) {
            return;
        }

        const itemImageLinks = container.querySelectorAll( '[data-image]' );

        if ( ! itemImageLinks.length ) {
            return;
        }

        // add the actual image elememt if it doesn't exist
        if ( ! megaMenuColImage.contains( megaMenuImage ) ) {
            megaMenuColImage.append( megaMenuImage );
        }

        itemImageLinks.forEach( elm => {
            const parentElm = elm.parentNode;

            elm.addEventListener( 'mouseenter', () => {
                setImage( elm.getAttribute( 'data-image' ) );
            });

            elm.addEventListener( 'mouseleave', () => {
                clearImage();
            });
        });
    }

    function clearImage( force = false ) {
        if ( ! force && megaMenuImage.hasAttribute( 'pinned' ) ) {
            return;
        }

        megaMenuImage.removeAttributes( 'src', 'pinned' );
    }

    function setImage( src, pin = false ) {
        if ( ! src || ( megaMenuImage.hasAttribute( 'pinned' ) && ! pin ) ) {
            return;
        }

        megaMenuImage.setAttribute( 'src', src );

        if ( pin ) {
            megaMenuImage.setAttribute( 'pinned', 'true' );
        }
    }

    function setItemActiveState( elm, clear = false ) {
        if ( clear ) {
            elm.removeAttribute( 'data-active' );
            return;
        }

        elm.setAttribute( 'data-active', 'true' );
    }

    function isItemActive( elm ) {
        return elm.hasAttribute( 'data-active' );
    }

    function hasSubmenu( elm ) {
        return elm.classList.contains( 'menu-item-has-children' );
    }

    function headerAnimationHandler ( e ) {
        let elm = e.target;
        const parentElm = elm.parentNode;
        let openAttribute = 'open';

        if ( elm.classList.contains( 'site-header__menu-wrapper' ) ) {
            elm = primaryHeader;

            if ( elm.hasAttribute( 'opening' ) ) {
                // console.log('menu is opening');
                elm.setAttribute( 'menu-open', '' );
                elm.removeAttribute( 'opening' );
                mainSubMenuLinks[0].click();
                setHeaderOffset();
            }

            return;
        }

        if ( elm.hasAttribute( 'opening' ) ) {
            // console.log( 'element is opening', elm );
            elm.setAttribute( openAttribute, '' );
            elm.removeAttribute( 'opening' );
            return;
        }

        if ( elm.hasAttribute( 'closing' ) ) {
            // console.log( 'element is closing', elm );
            elm.removeAttributes( openAttribute, 'closing' );
            return;
        }

        if ( elm.hasAttribute( 'last-item' ) ) {
            // console.log( 'last element finished animating', elm );
            megaMenuWrapper.setAttribute( 'loaded', '' );
            elm.removeAttribute( 'last-item' );
        }

        // menu-item
        if ( elm.classList.contains( 'menu-item') ) {
            // console.log('animationend', {elm, parentElm}, typeof onRemoveCallback);

            if ( elm.hasAttribute( 'removing' ) ) {
                elm.remove();

                if (
                    parentElm.children.length === 0
                    && typeof onRemoveCallback === 'function'
                ) {
                    onRemoveCallback();
                    onRemoveCallback = null;
                }
            }
        }
    }

    // watch for scroll state
    const scrollWatcher = document.createElement( 'div' );
    scrollWatcher.setAttribute( 'data-scroll-watcher', '' );
    primaryHeader.before( scrollWatcher );

    const navObserver = new IntersectionObserver( ([entry]) => {
        if ( primaryHeader.hasAttribute( 'menu-open' ) ) {
            return;
        }

        primaryHeader.toggleAttribute( 'is-sticking', !entry.isIntersecting );
    });

    navObserver.observe( scrollWatcher );

    // prepare megamenu image
    const megaMenuImage = document.createElement( 'img' );

    // adjust header offset
    setHeaderOffset();

    window.addEventListener( 'resize', () => {
        setHeaderOffset();
    });

    // handle animationend/transitionend in header
    Array( 'animationend', 'transitionend' ).forEach( event => {
        primaryHeader.addEventListener( event, headerAnimationHandler );
    } );

    // click handler in header
    primaryHeader.addEventListener( 'click', (e) => {
        const targetElm = e.target;
        const parentElm = targetElm.parentNode;

        if ( ! Array( 'A', 'BUTTON' ).includes( targetElm.nodeName ) ) {
            return;
        }

        // menu toggle
        if (
            targetElm.nodeName === 'BUTTON'
            && targetElm.hasAttribute( 'data-control' )
        ) {
            toggleMenu();
            return;
        }

        if ( ! targetElm.hasAttribute( 'href' ) ) {
            return;
        }

        // menu links
        if ( hasSubmenu( parentElm ) ) {
            e.preventDefault();
            targetElm.blur();
        }

        // main menu links
        if ( mainMenu.contains( targetElm ) ) {
            if (
                primaryHeader.hasAttribute( 'opening' )
                || megaMenuWrapper.hasAttribute( 'opening' )
            ) {
                return;
            }

            if ( hasSubmenu( parentElm ) )  {
                // console.log( 'main menu link WITH submenu' );

                if ( ! megaMenuWrapper.hasAttribute( 'open' ) ) {
                    megaMenuWrapper.setAttribute( 'opening', '' );
                }

                if (
                    isMobile
                    && isItemActive( parentElm )
                    && megaMenuWrapper.hasAttribute( 'open' )
                    && ! megaMenuColMain.classList.contains( 'act-as-subcol' )
                ) {
                    // console.log( 'mobile, active item clicked, megamenu open and no submenu' );
                    return;
                }

                // special action for mobile, menu item should act as a "back" link
                if ( isMobile ) {
                    setHeaderOffset();

                    if (
                        megaMenuColMain.classList.contains( 'act-as-subcol' )
                        && isItemActive( parentElm )
                    ) {
                        setItemActiveState( parentElm, true );
                    }
                }

                // menu item is already active, close megamenu
                if ( isItemActive( parentElm ) ) {
                    closeMegaMenu();
                    return;
                }

                clearActiveItem( mainMenu );
                clearMenuItems( megaMenuColSub );
                clearImage( true );

                setItemActiveState( parentElm );

                clearMenuItems( megaMenuColMain, () => {
                    megaMenuWrapper.querySelector( '.act-as-subcol' )?.classList.remove( 'act-as-subcol' );
                    copyMenuItems( parentElm, megaMenuColMain );
                });

            }
        }

        // megamenu "main" links
        if ( megaMenuColMain.contains( targetElm ) ) {
            // console.log('megamenu main', {targetElm, parentElm});

            if ( isViewportSize( ['small', 'medium'] ) ) {
                if ( ! hasSubmenu( parentElm ) ) {
                    return;
                }

                // console.log( 'mobile, copy elements to MAIN col not SUB col' );
                clearMenuItems( megaMenuColMain, () => {
                    megaMenuColMain.classList.add( 'act-as-subcol' );
                    copyMenuItems( parentElm, megaMenuColMain );
                });
            } else {
            //     if ( isItemActive( parentElm ) ) {
            //         return;
            //     }

            //     if ( targetElm.hasAttribute( 'data-image' ) ) {
            //         setImage( targetElm.getAttribute( 'data-image' ), true );
            //     }

            //     // console.log( 'NOT mobile, copy items to SUB col' );

            //     clearMenuItems( megaMenuColSub, () => {
            //         clearActiveItem( megaMenuColMain )
            //         copyMenuItems( parentElm, megaMenuColSub );
            //         setItemActiveState( parentElm );
            //     });
                window.location = targetElm.getAttribute( 'href' );
            }
        }
    });

    if ( window.viewportName === 'large' ) {

        Array( 'mouseover', 'focusin' ).forEach(event => {
            megaMenuColMain.addEventListener( event, (e) => {
                if ( e.target.nodeName !== 'A' || isItemActive( e.target.parentElement ) ) {
                    return;
                }

                // console.log(`megamenu main ${e.type}, do submenu stuff`, e);

                clearMenuItems( megaMenuColSub, () => {
                    clearActiveItem( megaMenuColMain )
                    copyMenuItems( e.target.parentElement, megaMenuColSub );
                    setItemActiveState( e.target.parentElement );
                });
            } );
        });

        window.addEventListener( 'keydown' , (e) => {
            if (
                e.key === 'Escape'
                && megaMenuWrapper.hasAttribute( 'open' )
            ) {
                closeMegaMenu();
            }
        });
    }

} )();
